import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'
import {TripTypes} from '../js/constants'
const uuidv4 = require('uuid/v4');

Vue.use(Vuex)

//for reset state check:
// https://github.com/vuejs/vuex/issues/1118#issuecomment-356286218
const defaultPlaceId = 'ChIJvwmEZ0eATo8RkrvqeK_-1F8';
const airportPlaces = ['ChIJvwmEZ0eATo8RkrvqeK_-1F8','ChIJCXi1SbuBTo8RBnrwoU3U9-c'];
const state = {
  hasSetting: false,
  staticCompanySettings: {},
  settings: {
  },
  phoneData: {},
  form: {
    adults: 1,
    kids: 0,
    coupon: null, //move to coupon
    currency: null,
    from: {},
    to: {},
    serviceTypeID: null,
    tripType: null,
    extras: [
      // {id: 4, trip: 1, quantity: 1}
    ],
    //form reservation
    arrivalFlightNumber: null,
    arrivalAirline:	null,
    arrivalFlightTime: null, //pending
    clientFirstName: null,
    clientLastName: null,
    clientEmail: null,
    clientPhone: null,
    clientNotes: null,
    clientLang: null,
    departureFlightNumber: null,
    departureAirline: null,
    departureFlightTime: null, //pending
    originPickUpTime: null,
    destinationPickUpTime: null,
    paymentMethod: null,
    pickUpTime: null,
  },
  formDates: {
      arrivalDate: null,
      arrivalHours: null,
      arrivalMinutes: null,
      departureDate: null,
      departureMinutes: null,
      departureHours: null,
      originDate: null,
      originHours: null,
      originMinutes: null,
      destinationDate: null,
      destinationHours: null,
      destinationMinutes: null,
      pickUpDate: null,
      pickUpHours: null,
      pickUpMinutes: null
  },
  info:{
    from: null,
    to: null,
    tripType: null,
    serviceType: null,
  },
  summary: {
      arrivalDate: null,
      arrivalHours: null,
      arrivalMinutes: null,
      departureDate: null,
      departureMinutes: null,
      departureHours: null,
      originDate: null,
      originHours: null,
      originMinutes: null,
      destinationDate: null,
      destinationHours: null,
      destinationMinutes: null,
  },
  //default placeId to airport...
  fromPlace: {
    placeId: defaultPlaceId,
    description: null,
    lat: null,
    lng: null,
    googleApiSessionToken: uuidv4()
  },
  toPlace: {
    placeId: defaultPlaceId,
    description: null,
    lat: null,
    lng: null,
    googleApiSessionToken: uuidv4()
  },
  extrasByIdTrip: {

  },
  tripType: TripTypes.AirportPlace,
  defaultPlaceId,
  airportPlaces,
  voucherToken: null,
  couponMaxPax: null,
  couponDescription: null,
  loadPaypalScript:false,
  loadedGa4:false,
  ga4Events:[],
  ga4Plugin:null,
}

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})

if (module.hot) {
  module.hot.accept([
    './getters',
    './actions',
    './mutations'
  ], () => {
    store.hotUpdate({
      getters: require('./getters'),
      actions: require('./actions'),
      mutations: require('./mutations')
    })
  })
}

export default store
